import React from 'react';
import { motion } from 'framer-motion';
export function Creator() {
  return <section className="py-20 bg-[#0B1426]" data-id="element-69">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#111827] border border-gray-800 rounded-2xl p-8 md:p-12 text-center" data-id="element-71">
          <h2 className="text-2xl font-bold text-gray-400 mb-8 uppercase tracking-widest text-sm" data-id="element-72">
            QUIÉN ESTÁ DETRÁS DE ESTO
          </h2>

          <div className="w-28 h-28 rounded-full mx-auto mb-6 border-2 border-blue-500 overflow-hidden shadow-lg shadow-blue-500/20" data-id="element-73">
            <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=200&h=200&fit=crop&crop=face" alt="Dr. Alejandro Vidal" className="w-full h-full object-cover" data-id="element-74" />
          </div>

          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-75">
            Dr. Alejandro Vidal
          </h3>

          <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-76">
            Neurólogo infantil con más de 15 años de experiencia clínica en TDAH
            y TEA. Formado en el Hospital Italiano de Buenos Aires y con
            posgrado en Neuropsicología en la Universidad de Favaloro. Atiende
            en consultorio privado y en el sistema público. Hoy más de 200
            colegas en toda Argentina usan su sistema en el día a día.
          </p>

          <blockquote className="text-xl italic text-gray-200 border-l-4 border-yellow-500 pl-6 text-left" data-id="element-77">
            "Desarrollé el Mega Kit Neuro-Pro después de calcular cuántas horas
            semanales perdía en trabajo que no era atender pacientes. El número
            me asustó. Decidí sistematizar todo lo que podía sistematizarse para
            devolvérmelo a mí y a mis colegas."
          </blockquote>
        </motion.div>
      </div>
    </section>;
}